export default __webpack_public_path__ + "static/media/logo.25675a4f.png";